import vehicle from './vehicle';
import vehicleViews from './vehicleViews';

const root = {
	vehicle,
	vehicleViews
};

export default root;
